import { AsyncPipe, NgComponentOutlet } from '@angular/common'
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { TranslateModule } from '@ngx-translate/core'

import { CompanyFacade, RouterFacade } from '~/core/features'
import { EGuardSection } from '~/core/models'
import { LoadingComponent } from '~/ui/loading'

import { StockPricePredictionsInfoComponent } from './components'

@Component({
  selector: 'app-stock-price-predictions',
  templateUrl: './stock-price-predictions.component.html',
  styleUrl: './stock-price-predictions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    TranslateModule,
    LoadingComponent,
    NgComponentOutlet,
    StockPricePredictionsInfoComponent,
  ],
})
export class StockPricePredictionsComponent {
  private readonly companyFacade = inject(CompanyFacade)
  readonly routerFacade = inject(RouterFacade)

  readonly contourChartComponent = signal<Promise<any> | null>(null)

  readonly impactIsolinesChartComponent = signal<Promise<any> | null>(null)

  readonly forecast = toSignal(this.companyFacade.forecast$)

  readonly guardSection = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_SCENARIOS
      : EGuardSection.FORECAST_INFO_SCENARIOS
  )

  readonly guardEpsContourChart = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_CHART_EPS_CONTOUR
      : EGuardSection.FORECAST_INFO_CHART_EPS_CONTOUR
  )

  readonly guardImpactIsoLinesChart = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_CHART_IMPACT_ISOLINES
      : EGuardSection.FORECAST_INFO_CHART_IMPACT_ISOLINES
  )

  readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  constructor() {
    afterNextRender(() => {
      this.contourChartComponent.set(
        import('./lazy-components/contour-chart-container/contour-chart-container.component').then(
          c => c.ContourChartContainerComponent
        )
      )

      this.impactIsolinesChartComponent.set(
        import(
          './lazy-components/impact-isolines-chart-container/impact-isolines-chart-container.component'
        ).then(c => c.ImpactIsolinesChartContainerComponent)
      )
    })
  }
}
